// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ProductBox{border:0;box-shadow:0 0 2rem transparent;display:flex;height:100%;position:relative;transition:box-shadow .6s cubic-bezier(.09,.92,.31,.98);z-index:1}.ProductBox:focus,.ProductBox:hover{box-shadow:0 0 2rem rgba(0,0,0,.2)}@media print{.ProductBox{box-shadow:none;page-break-inside:avoid;position:relative}}.ProductBox .AddToCart__buttonWrapper>.AppButton{margin-left:auto;max-width:7rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
